<ng-container *ngIf="vm$ | async as vm">
<h2 class="head2">Recente bladwijzers</h2>
<div class="c2-bladwijzers-rowmaincontent">
    <div class="bladwijzer-row" *ngFor="let bladwijzer of vm.bladwijzers trackBy:getBladwijzerId">
        <div class="bladwijzer-zittingmarker-col">
            <div [ngClass]="bladwijzer.AtHomeColorClass"></div>
        </div>
        <div class="bladwijzer-titel-col">
            <a role="link" tabindex="0" class="c2-clickable" (click)="detailAgendapuntSubj.next(bladwijzer)" >{{bladwijzer.Titel}}</a>
        </div>
    </div>
</div>
</ng-container>